<template>
  <div>
    <modal :size="'modal-large modal-mobile'"
           :close-strict="false"
           @close="$emit('close')"
    >
      <div slot="header">
        <h5 class="font-weight-bold">Save filters</h5>
      </div>
      <div class="body" slot="body">
        <div>
          <div class="col">
            <div class="select-wrap">
              <label>Name</label>
              <input type="text"
                     class="form-control"
                     v-model="name"
                     @keydown="clearError($event)"
              />
            </div>
            <error-field :errors="errors" field="name" />
          </div>
        </div>
      </div>
      <div slot="footer" class="d-flex justify-content-between mx-3 mt-auto">
        <button class="btn btn-secondary w-50 mr-2" @click="$emit('close')">
          Cancel
        </button>
        <button class="btn btn-primary w-50 ml-2" @click="saveFilters">
          Save
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import toastr from 'toastr';
import axios from 'axios';
import Errors from '../classes/Errors';
import Modal from './Modal';
import ErrorField from './ErrorField.vue';

export default {
  components: {
    ErrorField,
    Modal,
  },
  props: {
    filters: {
      type: Object,
      default: () => {},
    },
    route: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    errors: new Errors(),
    name: '',
  }),
  methods: {
    clearError() {
      this.errors.clear();
    },
    saveFilters() {
      if (typeof this.filters === 'object' && this.filters !== null) {
        Object.keys(this.filters).forEach(key => {
          if (Array.isArray(this.filters[key])) {
            this.filters[key] = this.filters[key].filter(n => n);
          }
        });
      }
      const data = {
        name: this.name,
        route: this.route,
        values: JSON.stringify(this.filters),
      };
      axios
        .post('/clusters/users/filters', data)
        .then(() => {
          toastr.success('Saved filters template');
          this.$emit('close');
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.scrollable-body {
  max-height: 400px;
  overflow: auto;
}

@media screen and (max-width: 600px) {
  .modal-large {
    height: 100vh !important;
    background-color: red !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SaveFiltersModal.vue